import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1)
const _hoisted_2 = { class: "mb-5 mt-5" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "flex justify-between card-header border-0 pt-6" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "my-1" }
const _hoisted_8 = { class: "p-input-icon-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "card-body pt-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)

import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { categoryService } from "@/_services/category/category";
import { filterService } from "@/_services/filter/category/filter";
import { ICategory } from "@/models/category/ICategory";
import { ICategoryFilter } from "@/models/filter/category/ICategoryFilter";
import { FilterMatchMode } from "primevue/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import router from "@/router";
import swal from "@/_helpers/swal";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryFiltersList',
  setup(__props) {


const trimInput = () => {
    filters.value.global.value = filters.value.global?.value?.trim();
};

const loading = ref<boolean>(true);
const title = ref<string>("");
const route = useRoute();
const rows = ref<number>(15);
const categoryFilters: ICategoryFilter[] = [];
const tableData = ref<Array<ICategoryFilter>>(categoryFilters);
const categoryUuidRouteParam = ref<string | null>(null);
const category = ref<ICategory | null>(null);

const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    'filterName': { value: null, matchMode: FilterMatchMode.CONTAINS },
});

onMounted(async () => {
    categoryUuidRouteParam.value = route.params.uuid as string;
    if (categoryUuidRouteParam.value) {
        category.value = await categoryService.fetchCategory(categoryUuidRouteParam.value);
        if (category.value) {
            title.value = category.value.name.toUpperCase();
            await populateDatatable(category.value.uuid);
        }
    }
});

const populateDatatable = async (categoryUuid: string) => {
    showSpinner();
    const [loadingDt, tableDataDt] = await filterService.getFiltersNamesLinkedToCategory(categoryUuid);
    loading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
};

const refreshDatatable = () => {
    if (category.value) {
        populateDatatable(category.value.uuid);
    }
};

const refreshPage = () => {
    window.location.reload();
};

const redirectToLastPage = () => {
    router.back();
};

const onCreateFilter = () => {
    if (!canAddProductFilterToCategory()) {
        swal.warning("Cette catégorie n'est associé à aucun produit pour l'instant, Veuillez l'associer à un produit avant de l'associer à des filtres !")
    } else {
        if (category.value) {
            router.push({ name: 'addCategoryFilter' , params: { uuid: category.value.uuid }});
        }
    }
}

function canAddProductFilterToCategory(): boolean {
    if (category.value) {
        return categoryService.canAddProductFilterToCategory(category.value);
    }
    return false;
}

const toggleStatus = (
    categoryFilter: ICategoryFilter,
    confirmMessage: string,
    successMessage: string,
    cancelButtonText?: string,
    confirmButtonText?: string,
    confirmButtonClass?: string,
    cancelButtonClass?: string,
) => {
    swal
    .confirm(confirmMessage, cancelButtonText, confirmButtonText, confirmButtonClass, cancelButtonClass)
    .then((result) => {
        if (result.isConfirmed) {
            showSpinner();
            filterService.toggleFilterStatus(categoryFilter.filterUuid, categoryFilter.isActive).then(() => {
                let state = categoryFilter.isActive ? "Activé !" : "Désactivé !"
                swal.success(state, successMessage).then((response) => {
                    if (response.isConfirmed) {
                        hideSpinner();
                    }
                });
            });
        } else {
            refreshDatatable();
        }
    });
};

const onDeleteCategoryFilter = (categoryFilter: ICategoryFilter, event) => {
    swal
        .confirm("Êtes-vous sûr de vouloir supprimer ce filtre ?", "Non", "Oui")
        .then((responseLevel1: object) => {
            if (responseLevel1.isConfirmed) {
                const filterHTMLLine = event.target.closest('tr');
                showSpinner();
                filterService.deleteCategoryFilter(categoryFilter.filterUuid).then(() => {
                    hideSpinner();
                    swal.success("Supprimé !", "Le filtre a été supprimé").then((responseLevel2: object) => {
                        if (responseLevel2.isConfirmed) {
                            refreshDatatable();
                        }
                    });
                });
            }
        });
};

const showSpinner = () => {
    loading.value = true;
}

const hideSpinner = () => {
    loading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToLastPage()))
    }, [
      _hoisted_1,
      _createTextVNode(" Retour ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        rows: rows.value,
        rowHover: true,
        loading: loading.value,
        rowsPerPageOptions: [15, 30, 50, 100],
        globalFilterFields: ['filterName'],
        paginator: "",
        filters: filters.value,
        "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => ((filters).value = $event)),
        template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "form-control w-[250px] ps-15",
                    modelValue: filters.value['global'].value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (trimInput())),
                    placeholder: "Rechercher un filtre"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (canAddProductFilterToCategory())
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_unref(Button), {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (onCreateFilter())),
                      label: "Ajouter un filtre",
                      class: "p-button-info",
                      icon: "pi pi-plus-circle"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_unref(Button), {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (onCreateFilter())),
                      label: "Ajouter un filtre",
                      class: "p-button-warning",
                      icon: "pi pi-info-circle"
                    })
                  ]))
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun filtre trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(Column), {
              field: "filterName",
              header: "Filtre"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.filterName), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "filterType",
              header: "Type de filtre"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.filterType), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_14
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-trash",
                  class: "p-button-danger",
                  style: {"margin-right":"0.5em"},
                  title: "supprimer",
                  onClick: ($event: any) => (onDeleteCategoryFilter(slotProps.data, $event))
                }, null, 8, ["onClick"]),
                _createVNode(_unref(InputSwitch), {
                  modelValue: slotProps.data.isActive,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.isActive) = $event),
                  "input-id": slotProps.data.filterPropertyUuid,
                  onInput: ($event: any) => (toggleStatus(
                                slotProps.data,
                                slotProps.data.isActive
                                ? `Êtes-vous sûr de vouloir activer ce filtre ?`
                                : `Êtes-vous sûr de vouloir désactiver ce filtre ?`,
                                slotProps.data.isActive
                                ? `Filtre activé, il sera visible sur la plateforme`
                                : `Filtre désactivé, il ne sera plus visible sur la plateforme`,
                                `Annuler`,
                                slotProps.data.isActive ? `Activer` : `Désctiver`,
                                slotProps.data.isActive
                                ? `btn btn-success`
                                : `btn btn-danger`,
                                `btn btn-secondary`
                            ))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "onInput"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "filters"])
    ])
  ], 64))
}
}

})